import React, { Component } from 'react';
import ItemListRecordColumn from './ItemListRecordColumn';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import showAlert from '../../../../common/utils/alert';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import { description } from '../../../../common/utils/event_constants';
import { isProjectReadOnly } from '../../../../common/utils/api_utils';

class ItemTableRow extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    fields: PropTypes.array.isRequired,
    item: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    onRowSelect: PropTypes.func,
  };

  static defaultProps = {
    isSelected: false,
    onRowSelect: () => {},
  };

  deleteItem = () => {
    const { projectId, selectedCollection, item, version, actions } = this.props;
    const preConfirm = () => {
      return actions.deleteItem({
        projectId: projectId,
        version,
        collectionName: selectedCollection.collectionName,
        itemId: item.uuid,
      });
    };
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };

  handleCheckboxChange = (e) => {
    const { item, onRowSelect } = this.props;
    onRowSelect(item.uuid, e.target.checked);
  };

  render() {
    const {
      fields,
      item,
      actions,
      selectedCollection,
      projectId,
      version,
      flag,
      iPlugins,
      s3Url,
      columnVisibility = {},
      isSelected,
      projectDetail,
    } = this.props;
    const isReadOnly = isProjectReadOnly(projectId);
    const { uuid, collectionName, restrictItem } = selectedCollection;
    return (
      <tr className={isSelected ? 'table-active' : ''}>
        <td
          style={{
            position: 'sticky',
            left: 0,
            backgroundColor: isSelected ? '#dadada' : '#fff',
            zIndex: 1,
            width: '60px',
            borderRight: '1px solid #e5e5e5',
          }}
        >
          <input
            type="checkbox"
            checked={isSelected}
            onChange={this.handleCheckboxChange}
            style={{
              cursor: 'pointer',
              width: '15px',
              height: '17px',
              accentColor: '#303453',
            }}
          />
        </td>
        {fields.map((field, i) => {
          if (Object.keys(columnVisibility).length && !columnVisibility[field.fieldName]) {
            return null;
          }
          return (
            <ItemListRecordColumn
              item={item}
              field={field}
              key={i}
              projectId={projectId}
              version={version}
              iPlugins={iPlugins}
              s3Url={s3Url}
              projectDetail={projectDetail}
            />
          );
        })}
        <td
          style={{
            position: 'sticky',
            right: 0,
            backgroundColor: '#fff',
            zIndex: 2,
            minWidth: '100px',
            padding: '8px',
            borderLeft: '1px solid #ddd',
          }}
        >
          {restrictItem ? (
            ''
          ) : (
            <Link
              to={
                isReadOnly
                  ? null
                  : `/collections/${version}/v/${projectId}/${uuid}/name/${collectionName}/items/${item.uuid}/edit`
              }
              className="btn btn-primary btn-xs"
              title={isReadOnly ? 'Read-Only Mode' : 'Edit'}
              style={{
                cursor: isReadOnly ? 'not-allowed' : 'pointer',
                opacity: isReadOnly ? '0.5' : '1',
              }}
            >
              <i className={`wb ${drapcodeIcon('edit')}`} />
            </Link>
          )}
          &nbsp;
          <button
            type="button"
            className="btn btn-theme-submit btn-xs"
            style={{ cursor: 'pointer' }}
            title="View"
            onClick={() => {
              actions.loadItemDetails({
                projectId,
                itemId: item.uuid,
                version,
                collectionName: collectionName,
              });
            }}
          >
            <i className={`wb ${drapcodeIcon('view')}`} />
          </button>
          &nbsp;
          {restrictItem ? (
            ''
          ) : (
            <button
              type="button"
              className="btn btn-theme-delete btn-xs"
              title={isReadOnly ? 'Read-Only Mode' : 'Delete Item'}
              onClick={flag ? this.deleteItem : undefined}
              disabled={isReadOnly}
              style={{ cursor: flag && !isReadOnly ? 'pointer' : 'not-allowed' }}
            >
              <i className={`wb ${drapcodeIcon('remove')}`} />
              {flag ? null : (
                <>
                  &nbsp;
                  <TooltipInfo
                    title={description}
                    headerText="Permission Disabled!"
                    showHeader={true}
                    showArrow={true}
                  />
                </>
              )}
            </button>
          )}
        </td>
      </tr>
    );
  }
}

export default ItemTableRow;
